import React, { useMemo } from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled, { css } from 'styled-components';

import { CustomEventNames, EventTypes } from 'state/mParticle/constants';

import { StyledRedemptionButton } from './redemption-button.styled';
import theme from './theme';
import { IRedemptionButton, RestaurantRedemptionButtonUiOption } from './types';

const pCss = css`
  margin: 0;
  font-family: ${Styles.fontFamily.body};
  color: ${theme.pCssColor};
  text-align: center;
`;

const restaurantRedemptionCss = css`
  width: auto;
  min-width: 234px;
  margin-top: 1rem;

  ${Styles.desktop`
    margin-top: 2rem;
  `}
`;

const RestaurantOfferText = styled.p`
  ${pCss}
  ${restaurantRedemptionCss}
  font-size: 0.8rem;
`;

const RestaurantOfferButtonText = styled.span`
  ${pCss}
  cursor: pointer;
  font-size: 0.8rem;
  display: inline;
  text-decoration: underline;
`;

export const RedemptionButton: React.FC<IRedemptionButton> = ({
  onClickRestaurantRedemption,
  restaurantRedemptionButtonTitle,
  restaurantRedemptionButtonUiType,
  disabled,
  isDesktop,
}) => {
  const { formatMessage } = useIntl();
  const clickHereText = formatMessage({ id: 'restaurantRedemptionClickHere' });
  const restaurantRedemptionText = useMemo(
    () =>
      formatMessage(
        { id: 'restaurantRedemption' },
        {
          clickHere: (
            <RestaurantOfferButtonText
              role="button"
              onClick={onClickRestaurantRedemption}
              data-testid="restaurant-redemption-button"
            >
              {clickHereText}
            </RestaurantOfferButtonText>
          ),
        }
      ),
    [clickHereText, formatMessage, onClickRestaurantRedemption]
  );

  return restaurantRedemptionButtonUiType === RestaurantRedemptionButtonUiOption.BUTTON ? (
    <Box margin={isDesktop ? '1.2rem 0 0' : '1rem 0 0'}>
      <StyledRedemptionButton
        data-testid="restaurant-redemption-button"
        onClick={onClickRestaurantRedemption}
        eventName={CustomEventNames.OFFER_CODE_REQUESTED}
        eventType={EventTypes.Other}
        disabled={disabled}
      >
        {restaurantRedemptionButtonTitle}
      </StyledRedemptionButton>
    </Box>
  ) : (
    <RestaurantOfferText>{restaurantRedemptionText}</RestaurantOfferText>
  );
};
